import { render, staticRenderFns } from "./PaycoLoginPopup.vue?vue&type=template&id=227f432d&"
import script from "./PaycoLoginPopup.vue?vue&type=script&lang=ts&"
export * from "./PaycoLoginPopup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports